// Main IIFE to avoid global scope pollution
(function() {
    'use strict';

    // Configuration
    const CONFIG = {
        selectors: {
            // Updated selectors for WooCommerce Blocks 8.0+
            checkoutWrapper: '.wc-block-checkout, .wc-block-checkout__main, .wc-block-components-main',
            checkoutForm: 'form.woocommerce-checkout, form.wc-block-checkout__form',
            // Look for billing fields container
            billingFields: '.wc-block-components-address-form, .wc-block-checkout__billing-fields, .woocommerce-billing-fields',
            // Look for email field as a reference point
            emailField: '#billing_email, [name="billing_email"], .wc-block-components-address-form__email',
            addressForBilling: 'div.wc-block-checkout__use-address-for-billing',
            shippingOption: 'fieldset#shipping-option',
            vatInput: '#billing_vat_number, [name="billing_vat_number"]'
        },
        classes: {
            checkboxWrapper: 'wc-block-components-checkbox',
            checkboxInput: 'wc-block-components-checkbox__input',
            checkboxMark: 'wc-block-components-checkbox__mark',
            checkboxLabel: 'wc-block-components-checkbox__label',
            contentContainer: 'woocommerce-billing-fields',
            vatField: 'form-row form-row-wide',
            vatLabel: 'woocommerce-form__label'
        },
        text: {
            checkboxLabel: 'I am buying as a business, not as a private person.',
            vatLabel: 'VAT Number'
        }
    };

    // DOM Elements
    let elements = {};

    // Initialize the checkout functionality
    function initCheckout() {
        setupEventListeners();
        waitForCheckoutForm();
    }

    // Set up event listeners
    function setupEventListeners() {
        // Watch for dynamic content changes
        const observer = new MutationObserver(handleMutations);
        observer.observe(document.body, { childList: true, subtree: true });

        // Find the checkout form - try multiple selectors
        const formSelectors = [
            'form.checkout',
            'form.woocommerce-checkout',
            '.wc-block-checkout__form',
            'form.wc-block-components-form',
            '#order_review',
            '#order_review_heading',
            '.wc-block-checkout',
            'form.woocommerce-form.woocommerce-checkout',
            'form.woocommerce-checkout-form',
            'form[action*="checkout"]',
            'form[action*="order-pay"]',
            'form[action*="order-received"]',
            'form[data-block-name*="checkout"]',
            'form[data-block-name*="woocommerce"]'
        ];
        
        let checkoutForm = null;
        let formSelector = '';
        
        // Try to find the form
        for (const selector of formSelectors) {
            const forms = document.querySelectorAll(selector);
            if (forms.length > 0) {
                for (const form of forms) {
                    
                    // If this looks like a checkout form, use it
                    if (form.tagName === 'FORM' || form.querySelector('form') || 
                        form.className.includes('checkout') || 
                        form.className.includes('woocommerce') ||
                        form.id.includes('checkout') ||
                        form.id.includes('order')) {
                        checkoutForm = form;
                        formSelector = selector;
                        break;
                    }
                }
                if (checkoutForm) break;
            }
        }
        
        if (checkoutForm) {
            // For WooCommerce Blocks, we need to use their API to handle submission
            if (window.wc && window.wc.blocksCheckout) {
                
                // Get the cart data store
                const cartDataStore = wp.data.select('wc/store/cart');
                const cartDispatch = wp.data.dispatch('wc/store/cart');
                const checkoutDataStore = wp.data.select('wc/store/checkout');
                const checkoutDispatch = wp.data.dispatch('wc/store/checkout');
                
                // Track if we're currently updating to prevent loops
                let isUpdating = false;
                
                // Function to update VAT data
                const updateVatData = (source = 'manual') => {
                    try {
                        const vatInput = document.getElementById('billing_vat_number');
                        const vatNumber = vatInput ? vatInput.value.trim() : '';
                        
    
                        
                        // Update billing address with VAT number
                        const cartData = cartDataStore.getCartData();
                        cartDispatch.setBillingAddress({
                            ...(cartData.billingAddress || {}),
                            vat_number: vatNumber
                        });
                        

                        
                    } catch (error) {
                        console.error('Error updating VAT data:', error);
                    }
                };
                
                // Simple event listener for VAT input changes
                const handleVatChange = (e) => {
                    updateVatData('input');
                };

                // Set up event listeners for VAT input
                const setupVatInput = () => {
                    const vatInput = document.getElementById('billing_vat_number');
                    if (vatInput) {
                        // Remove any existing listeners to avoid duplicates
                        vatInput.removeEventListener('change', handleVatChange);
                        vatInput.removeEventListener('blur', handleVatChange);
                        vatInput.removeEventListener('input', handleVatChange);
                        
                        // Add new listeners
                        vatInput.addEventListener('change', handleVatChange);
                        vatInput.addEventListener('blur', handleVatChange);
                        vatInput.addEventListener('input', handleVatChange);
                        
    
                        return true;
                    }
                    return false;
                };
                
                // Initial setup
                if (!setupVatInput()) {
                    // If VAT input isn't available yet, set up a mutation observer
                    const observer = new MutationObserver((mutations, obs) => {
                        if (setupVatInput()) {
                            obs.disconnect();
                        }
                    });
                    
                    observer.observe(document.body, {
                        childList: true,
                        subtree: true
                    });
                }
                
                // Initial update
                updateVatData('init');
                

            } else {
                // Fallback for non-blocks checkout
                // Add our submit handler directly to the form
                checkoutForm.addEventListener('submit', function(e) {
                    // Prevent default form submission
                    if (e.preventDefault) e.preventDefault();
                    if (e.stopPropagation) e.stopPropagation();
                    try {
                        // Call our custom handler
                        handleFormSubmit(e);
                    } catch (error) {
                        console.error('Error in form submission handler:', error);
                    }
                    
                    // Prevent form submission
                    return false;
                }, true);
                
                // Also try to intercept the button click
                const submitButtons = document.querySelectorAll('button[type="submit"], input[type="submit"]');
                submitButtons.forEach(button => {
                    button.addEventListener('click', function(e) {
                        // Don't prevent default here, let the form submit handler handle it
                    }, true);
                });
            }
            
        } else {
            console.error('Could not find checkout form using any selectors');
        }
    }

    // Handle mutations in the DOM
    function handleMutations(mutations) {
        mutations.forEach(mutation => {
            if (mutation.addedNodes.length > 0 && !document.getElementById('toggle-checkbox')) {
                waitForCheckoutForm();
            }
        });
    }

// Handle form submission
function handleFormSubmit(e) {
    // Always try to prevent default behavior
    if (e && e.preventDefault) {
        e.preventDefault();
    }
    if (e && e.stopPropagation) {
        e.stopPropagation();
    }
    
    // Update the VAT field
    updateVatField();
    
    // Get the VAT number
    const vatNumber = elements.vatInput ? elements.vatInput.value.trim() : '';

    
    // For WooCommerce Blocks API
    if (window.wc && window.wc.blocksCheckout) {

        
        // Get current extensions data
        const extensionsData = wc.wcBlocksData.getExtensionData('woocommerce-checkout') || {};

        
        // Update with VAT number
        if (vatNumber) {
            const newData = {
                ...extensionsData,
                vat_number: vatNumber
            };

            
            try {
                wc.wcBlocksData.setExtensionData('woocommerce-checkout', newData);

                
                // Also add to form data as hidden field
                const hiddenField = document.createElement('input');
                hiddenField.type = 'hidden';
                hiddenField.name = 'billing_vat_number';
                hiddenField.value = vatNumber;
                e.target.appendChild(hiddenField);

            } catch (error) {
                console.error('Error setting extensions data:', error);
            }
        }
    }
    

    
    // Prevent form submission
    if (e.cancelable) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
    }
    return false;
}

    // Wait for checkout form to be available
    function waitForCheckoutForm() {
        // Try to find the email field as a reference point
        const emailField = document.querySelector(CONFIG.selectors.emailField);
        if (emailField) {
            clearTimeout(window.checkoutFormTimeout);
            // Add a small delay to ensure all form elements are fully loaded
            window.checkoutFormTimeout = setTimeout(() => addToggleElements(emailField.closest('form')), 300);
        } else {
            // If email field not found, try again in 500ms
            window.checkoutFormTimeout = setTimeout(waitForCheckoutForm, 500);
        }
    }

    // Add toggle elements to the DOM
    function addToggleElements(form = document) {
        // Prevent duplicate elements
        if (document.getElementById('toggle-checkbox') || document.getElementById('toggle-content')) {
            return;
        }

        // Create the elements
        createCheckbox();
        createVatInput();
        
        // Try to find a good spot to insert the VAT field
        const emailField = form.querySelector(CONFIG.selectors.emailField);
        const billingFields = form.querySelector(CONFIG.selectors.billingFields);
        
        if (emailField && emailField.closest('div')) {
            // Insert after the email field's parent container
            const emailContainer = emailField.closest('div');
            const wrapper = document.createElement('div');
            wrapper.className = 'business-vat-wrapper';
            wrapper.style.margin = '1em 0';
            
            // Insert after the email field container
            emailContainer.parentNode.insertBefore(wrapper, emailContainer.nextSibling);
            
            // Add our elements to the wrapper
            if (elements.checkboxWrapper) wrapper.appendChild(elements.checkboxWrapper);
            if (elements.contentContainer) wrapper.appendChild(elements.contentContainer);
            
        } else if (billingFields) {
            // Fallback: Insert at the end of billing fields
            billingFields.appendChild(elements.checkboxWrapper);
            billingFields.appendChild(elements.contentContainer);

        } else {
            // Last resort: Add to the end of the form
            form.appendChild(elements.checkboxWrapper);
            form.appendChild(elements.contentContainer);

        }
    }

    // Create the business checkbox
    function createCheckbox() {
        const checkboxId = `checkbox-control-${Math.floor(Math.random() * 1000)}`;
        
        // Create checkbox
        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.id = checkboxId;
        checkbox.className = CONFIG.classes.checkboxInput;
        checkbox.setAttribute('aria-invalid', 'false');

        // Create SVG checkmark
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('class', CONFIG.classes.checkboxMark);
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('viewBox', '0 0 24 20');
        
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', 'M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z');
        svg.appendChild(path);

        // Create label
        const label = document.createElement('label');
        label.htmlFor = checkboxId;
        
        const span = document.createElement('span');
        span.className = CONFIG.classes.checkboxLabel;
        span.textContent = CONFIG.text.checkboxLabel;

        // Assemble checkbox
        label.append(checkbox, svg, span);
        
        elements.checkboxWrapper = document.createElement('div');
        elements.checkboxWrapper.className = CONFIG.classes.checkboxWrapper;
        elements.checkboxWrapper.appendChild(label);
    }

    // Create VAT input field
    function createVatInput() {
        // Create container
        elements.contentContainer = document.createElement('div');
        elements.contentContainer.id = 'toggle-content';
        elements.contentContainer.className = CONFIG.classes.contentContainer;
        elements.contentContainer.style.cssText = 'display: none; margin: 20px 0;';
        
        // Create VAT field
        const vatField = document.createElement('p');
        vatField.className = CONFIG.classes.vatField;
        vatField.style.margin = '0 0 20px';

        // Create label
        const vatLabel = document.createElement('label');
        vatLabel.htmlFor = 'billing_vat_number';
        vatLabel.textContent = CONFIG.text.vatLabel;
        vatLabel.className = CONFIG.classes.vatLabel;
        vatLabel.style.cssText = 'display: block; margin-bottom: 8px; font-weight: 500;';

        // Create input
        elements.vatInput = document.createElement('input');
        elements.vatInput.type = 'text';
        elements.vatInput.id = 'billing_vat_number';
        elements.vatInput.name = 'billing_vat_number';
        elements.vatInput.className = 'input-text';
        elements.vatInput.setAttribute('data-store-api-key', 'billing_address.vat_number');
        elements.vatInput.style.cssText = 'width: 100%; padding: 12px; border: 1px solid #ddd; border-radius: 4px; box-sizing: border-box;';

    // Assemble checkbox
    label.append(checkbox, svg, span);
    
    elements.checkboxWrapper = document.createElement('div');
    elements.checkboxWrapper.className = CONFIG.classes.checkboxWrapper;
    elements.checkboxWrapper.appendChild(label);
}

// Create VAT input field
function createVatInput() {
    // Create container
    elements.contentContainer = document.createElement('div');
    elements.contentContainer.id = 'toggle-content';
    elements.contentContainer.className = CONFIG.classes.contentContainer;
    elements.contentContainer.style.cssText = 'display: none; margin: 20px 0;';
    
    // Create VAT field
    const vatField = document.createElement('p');
    vatField.className = CONFIG.classes.vatField;
    vatField.style.margin = '0 0 20px';

    // Create label
    const vatLabel = document.createElement('label');
    vatLabel.htmlFor = 'billing_vat_number';
    vatLabel.textContent = CONFIG.text.vatLabel;
    vatLabel.className = CONFIG.classes.vatLabel;
    vatLabel.style.cssText = 'display: block; margin-bottom: 8px; font-weight: 500;';

    // Create input
    elements.vatInput = document.createElement('input');
    elements.vatInput.type = 'text';
    elements.vatInput.id = 'billing_vat_number';
    elements.vatInput.name = 'billing_vat_number';
    elements.vatInput.className = 'input-text';
    elements.vatInput.setAttribute('data-store-api-key', 'billing_address.vat_number');
    elements.vatInput.style.cssText = 'width: 100%; padding: 12px; border: 1px solid #ddd; border-radius: 4px; box-sizing: border-box;';

    // Assemble VAT field
    vatField.append(vatLabel, elements.vatInput);
    elements.contentContainer.appendChild(vatField);
    
    // Add additional paragraph
    const additionalParagraph = document.createElement('p');
    additionalParagraph.className = 'wc-block-components-checkout-step__description';
    additionalParagraph.textContent = 'Please enter a valid VAT number and place your order. We will get in touch with a quote for you as a business customer with a custom VAT calculation depending on your location.';
    additionalParagraph.style.margin = '10px 0 0';
    additionalParagraph.style.lineHeight = '1.3';
    elements.contentContainer.appendChild(additionalParagraph);

        // Add event listeners
    const checkbox = elements.checkboxWrapper.querySelector('input[type="checkbox"]');
    if (checkbox) {
        // Remove any existing listeners to prevent duplicates
        const newCheckbox = checkbox.cloneNode(true);
        checkbox.parentNode.replaceChild(newCheckbox, checkbox);
        
        // Add new listener
        newCheckbox.addEventListener('change', handleCheckboxChange);
        
        // Initialize the button state with multiple attempts
        const initButtonState = () => {
            updatePlaceOrderButtonState();
            // Try again if button not found yet
            const placeOrderButton = document.querySelector('button[name="woocommerce_checkout_place_order"], #place_order, #place-order, .wc-block-checkout__submit-button');
            if (!placeOrderButton) {
                setTimeout(initButtonState, 500);
            }
        };
        
        // Initial setup
        setTimeout(initButtonState, 100);
        setupVatInputListeners();
    }
}

// Toggle payment methods based on business status
function togglePaymentMethods(isBusiness) {
    // Find all payment method radio inputs
    const paymentRadios = document.querySelectorAll('input[name^="radio-control-wc-payment-method-options"]');
    
    if (!paymentRadios.length) return;
    
    paymentRadios.forEach(radio => {
        const paymentMethod = radio.closest('.wc-block-components-radio-control-accordion-option');
        if (!paymentMethod) return;
        
        const isBankTransfer = radio.value === 'bacs';
        
        if (isBusiness) {
            // Hide all non-bank-transfer methods
            if (!isBankTransfer) {
                paymentMethod.style.display = 'none';
            } else {
                // Ensure bank transfer is selected and visible
                paymentMethod.style.display = '';
                radio.checked = true;
                radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
        } else {
            // Show all methods when not in business mode
            paymentMethod.style.display = '';
        }
    });
}

// Handle checkbox change event
function handleCheckboxChange(e) {
    const isChecked = e.target.checked;
    elements.contentContainer.style.display = isChecked ? 'block' : 'none';
    
    if (!isChecked) {
        elements.vatInput.value = '';
    }
    
    // Toggle payment methods
    togglePaymentMethods(isChecked);
    
    // Update the PLACE ORDER button state
    updatePlaceOrderButtonState();
}

// Update the PLACE ORDER button state based on VAT number validity
function updatePlaceOrderButtonState() {
    try {
        const checkbox = elements.checkboxWrapper?.querySelector('input[type="checkbox"]');
        const vatInput = elements.vatInput;
        
        // Try multiple selectors to find the place order button
        let placeOrderButton = document.querySelector('button[name="woocommerce_checkout_place_order"], #place_order, #place-order, .wc-block-checkout__submit-button');
        
        // If still not found, try more generic approach
        if (!placeOrderButton) {
            const buttons = document.querySelectorAll('button');
            for (const btn of buttons) {
                if (btn.textContent.trim().toLowerCase().includes('place order') || 
                    btn.textContent.trim().toLowerCase().includes('pay')) {
                    placeOrderButton = btn;
                    break;
                }
            }
        }
        
        if (!placeOrderButton) {
            console.warn('Could not find place order button');
            return;
        }
        
        const isBusiness = checkbox?.checked;
        const hasVat = vatInput?.value.trim() !== '';
        
        if (isBusiness) {
            // If business is checked, disable button if VAT is empty
            placeOrderButton.disabled = !hasVat;
            
            // Add a class for styling if needed
            if (!hasVat) {
                placeOrderButton.classList.add('disabled-due-to-vat');
                placeOrderButton.setAttribute('title', 'Please enter a valid VAT number');
            } else {
                placeOrderButton.classList.remove('disabled-due-to-vat');
                placeOrderButton.removeAttribute('title');
            }
            
            // Also set cursor style
            placeOrderButton.style.cursor = hasVat ? 'pointer' : 'not-allowed';
        } else {
            // Always enable button if not a business
            placeOrderButton.disabled = false;
            placeOrderButton.classList.remove('disabled-due-to-vat');
            placeOrderButton.removeAttribute('title');
            placeOrderButton.style.cursor = 'pointer';
        }
    } catch (error) {
        console.error('Error updating place order button:', error);
    }
}

// Add event listener for VAT input changes
function setupVatInputListeners() {
    if (elements.vatInput) {
        elements.vatInput.addEventListener('input', updatePlaceOrderButtonState);
    }
}

    // Insert elements into the DOM
    function insertElements() {
        // Insert checkbox after billing address
        const addressForBilling = document.querySelector(CONFIG.selectors.addressForBilling);
        if (addressForBilling?.parentNode) {
            addressForBilling.parentNode.insertBefore(
                elements.checkboxWrapper,
                addressForBilling.nextSibling
            );
        }

        // Insert VAT input after shipping option
        const shippingOption = document.querySelector(CONFIG.selectors.shippingOption);
        if (shippingOption?.parentNode) {
            shippingOption.parentNode.insertBefore(
                elements.contentContainer,
                shippingOption
            );
        }
    }

    // Update VAT field in form submission
    function updateVatField() {
        if (!elements.vatInput) return;

        const vatValue = elements.vatInput.value.trim();
        if (!vatValue) return;

        // Remove existing hidden field if it exists
        const existingField = document.querySelector('input[name="billing_vat_number"][type="hidden"]');
        if (existingField) {
            existingField.remove();
        }

        // Add new hidden field
        const vatField = document.createElement('input');
        vatField.type = 'hidden';
        vatField.name = 'billing_vat_number';
        vatField.value = vatValue;
        document.querySelector(CONFIG.selectors.checkoutForm)?.appendChild(vatField);
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initCheckout);
    } else {
        initCheckout();
    }

})();